import { useVKUIPlatform } from '@dui';

export function useCheckDesktop() {
  return useVKUIPlatform() === 'vkcom';
}
